import { MinHeap } from "utils/dataStructures/MinHeap";
import { Dijkstra } from "./types";

export const dijkstra: Dijkstra = ({ graph, startNodeId }) => {
  const distances: Record<string, number> = {};
  const previous: Record<string, string> = {};
  const visited = new Set<string>();

  // Initialize distances
  distances[startNodeId] = 0;

  const pq = new MinHeap<string>();
  pq.push(0, startNodeId);

  while (pq.size > 0) {
    const item = pq.pop()!;
    const currDist = item.key;
    const curr = item.value;

    if (visited.has(curr)) continue;
    visited.add(curr);

    // Access neighbors directly from the Graph
    const neighbors = graph[curr] ?? [];

    for (const [neighbor, weight] of neighbors) {
      // Safety check for weight
      const safeWeight = typeof weight === "number" ? weight : 1;

      const newDist = currDist + safeWeight;
      const oldDist = distances[neighbor] ?? Infinity;

      if (newDist < oldDist) {
        distances[neighbor] = newDist;
        previous[neighbor] = curr;
        pq.push(newDist, neighbor);
      }
    }
  }

  return { distances, previous };
};
